// ============================================================
// Keyboard-accessible Navigation — FEHN & Kollegen
// ============================================================
// Makes the .mainnav dropdown menus fully keyboard-navigable:
//   - Parent items with submenus (rendered as <strong> by Contao)
//     become focusable and toggle their submenu on Enter/Space
//   - Escape closes the open submenu and returns focus to parent
//   - Clicking outside closes any open submenu
//   - Proper ARIA attributes are managed automatically
//
// CMS note: Contao renders the active/trail parent as <strong>
// instead of <a>. This script makes those <strong> elements
// focusable and interactive.
// ============================================================

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var nav = document.querySelector('.mainnav');
    if (!nav) return;

    // Find all top-level <li> that contain a .level_2 submenu
    var parentItems = nav.querySelectorAll('ul.level_1 > li.submenu');

    for (var i = 0; i < parentItems.length; i++) {
      initSubmenuParent(parentItems[i]);
    }

    // Close any open submenu when clicking outside
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) {
        closeAll();
      }
    });

    // Close on Escape anywhere
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll();
      }
    });

    // --------------------------------------------------------
    // Helpers
    // --------------------------------------------------------

    function initSubmenuParent(li) {
      var submenu = li.querySelector('.level_2');
      if (!submenu) return;

      // The trigger can be an <a> or a <strong> (Contao active/trail)
      var trigger = li.querySelector(':scope > a, :scope > strong');
      if (!trigger) return;

      // Make <strong> focusable and announce as a button
      if (trigger.tagName === 'STRONG') {
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('role', 'button');
      }

      // ARIA: mark as having a popup, initially collapsed
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');

      // Give the submenu a role
      submenu.setAttribute('role', 'menu');

      // Mark submenu links with role
      var menuLinks = submenu.querySelectorAll('a, strong');
      for (var j = 0; j < menuLinks.length; j++) {
        menuLinks[j].setAttribute('role', 'menuitem');
        if (menuLinks[j].tagName === 'STRONG') {
          menuLinks[j].setAttribute('tabindex', '0');
        }
      }

      // ---- Events on the trigger ----

      // Toggle on click (for <strong> and <a>)
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(li, trigger, submenu);
      });

      // Keyboard: Enter/Space to toggle, Escape to close
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          toggle(li, trigger, submenu);
        }
        if (e.key === 'Escape') {
          close(li, trigger, submenu);
          trigger.focus();
        }
        // Arrow down: open and focus first item
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(li, trigger, submenu);
          var first = submenu.querySelector('a, [tabindex="0"]');
          if (first) first.focus();
        }
      });

      // ---- Events inside the submenu ----

      submenu.addEventListener('keydown', function (e) {
        var items = submenu.querySelectorAll('a, [tabindex="0"]');
        var idx = Array.prototype.indexOf.call(items, document.activeElement);

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (idx < items.length - 1) items[idx + 1].focus();
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (idx > 0) {
            items[idx - 1].focus();
          } else {
            // Back to trigger
            close(li, trigger, submenu);
            trigger.focus();
          }
        }
        if (e.key === 'Escape') {
          close(li, trigger, submenu);
          trigger.focus();
        }
        if (e.key === 'Tab') {
          // Let tab work naturally but close after last item
          // (browser will move focus out)
          requestAnimationFrame(function () {
            if (!li.contains(document.activeElement)) {
              close(li, trigger, submenu);
            }
          });
        }
      });

      // Close when focus leaves the entire <li> (covers Tab out)
      li.addEventListener('focusout', function () {
        requestAnimationFrame(function () {
          if (!li.contains(document.activeElement)) {
            close(li, trigger, submenu);
          }
        });
      });
    }

    function toggle(li, trigger, submenu) {
      var isOpen = li.classList.contains('submenu--open');
      closeAll();
      if (!isOpen) {
        open(li, trigger, submenu);
      }
    }

    function open(li, trigger, submenu) {
      li.classList.add('submenu--open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close(li, trigger, submenu) {
      li.classList.remove('submenu--open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function closeAll() {
      var allOpen = nav.querySelectorAll('.submenu--open');
      for (var k = 0; k < allOpen.length; k++) {
        var t = allOpen[k].querySelector(':scope > a, :scope > strong');
        allOpen[k].classList.remove('submenu--open');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    }
  });
})();
